module.exports = __webpack_public_path__ + "static/freelogo-88f3c028afc381156ae75b6e9a7ca065.png";